import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { version } from '../package.json';
import { Environment } from './config/environment';
import { app } from './config/firebase';
import App from './App';
import './index.css';

declare const __BUILD_TIME__: string;

const buildTime = __BUILD_TIME__;

console.log(
  `%c AssetsFlow Admin %c v${version} %c ${Environment.label} %c ${buildTime}`,
  'background:#2563eb;color:#fff;padding:4px 8px;border-radius:3px 0 0 3px;font-weight:bold',
  'background:#1e40af;color:#fff;padding:4px 8px',
  `background:${Environment.isProd ? '#dc2626' : '#ca8a04'};color:#fff;padding:4px 8px;font-weight:bold`,
  'background:#374151;color:#9ca3af;padding:4px 8px;border-radius:0 3px 3px 0',
);

const actualProject = app.options.projectId;
if (Environment.isProd && actualProject !== 'assetflow-backend-2024') {
  console.error(`[FATAL] Project mismatch: expected assetflow-backend-2024, got ${actualProject}`);
}
if (!Environment.isProd && actualProject !== 'assetflow-dev-f6fa5') {
  console.error(`[FATAL] Project mismatch: expected assetflow-dev-f6fa5, got ${actualProject}`);
}
console.log(`Firebase project: ${actualProject}`);

const host = location.hostname;
const isDevHost = host.includes('dev') || host === 'localhost' || host === '127.0.0.1';
const isProdHost = host.includes('admin-panel') || host.includes('prod');
if ((isDevHost && Environment.isProd) || (isProdHost && Environment.isDev)) {
  console.error(
    `[ENVIRONMENT MISMATCH] ${Environment.label} build deployed to ${host}. ` +
      `Expected: ${Environment.isProd ? 'prod' : 'dev'} host. Do NOT use this deploy.`,
  );
}

window.addEventListener('unhandledrejection', (event) => {
  console.error('[Unhandled Promise]', event.reason);
});

window.addEventListener('error', (event) => {
  console.error('[Unhandled Error]', event.error ?? event.message);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
